/**
 * 🟥 CUADRO NEGRO API Insights v1 (feb-2026) — hook unificado.
 *
 * Carga summary + tools + recommendations + alerts en paralelo
 * cuando cambia `userId`. Devuelve `{summary, tools, recommendations,
 * alerts, loading}`. Sin Redux/Zustand/SWR/React Query — fetch
 * vanilla con useState/useEffect como pide el Cuadro Negro.
 */
import { useEffect, useState } from "react";
import {
  fetchSummary,
  fetchTools,
  fetchRecommendations,
  fetchAlerts,
} from "../services/insightsService";

export function useInsights(userId) {
  const [summary, setSummary] = useState(null);
  const [tools, setTools] = useState(null);
  const [recommendations, setRecommendations] = useState(null);
  const [alerts, setAlerts] = useState(null);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const s = await fetchSummary(userId);
      const t = await fetchTools(userId);
      const r = await fetchRecommendations(userId);
      const a = await fetchAlerts(userId);

      setSummary(s);
      setTools(t);
      setRecommendations(r);
      setAlerts(a);
      setLoading(false);
    }
    load();
  }, [userId]);

  return { summary, tools, recommendations, alerts, loading };
}
